<template>
  <div v-if="load">
    <scale-loader/>
  </div>
  <div v-else-if="profile == null">
    <div class="wrapper-full-page section content">
      <div class="">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
              <h2 class="title text-danger">
                EsimProfile: {{cur_id}} not found
              </h2>
              <router-link :to="{path:'/esim_profile_list'}">
                To List EsimProfile
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <tabs parent="esim_profile" v-else>
    <tab id="profile" :name="translate('esim_profile.section.profile')" :href="url+'/profile'" >
      <Profile :id="cur_id" :profile="profile" ref="profile" @change="set_simcard"/>
    </tab>

    <!-- <tab id="actions" :name="translate('esim_profile.section.actions')" :href="url+'/actions'">
      <Actions :sim_id="cur_id" :profile="profile"/>
    </tab> -->

  </tabs>
</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Profile from './Profile/Index.vue'
// import Actions from './EsimProfile/Actions'

export default {
  name: 'EsimProfile',
  components: {
    Profile,
    // Actions,
    Tab,
    Tabs,
  },
  data () {
    return {
      pred_id: false,
      section: 'profile',
      interval: null,
      simcard: {},
      change: false,
      active: false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  beforeRouteUpdate(to, from, next) {
    this.ProveSaveOnLeave(next)
  },

  computed: {
    url () { return '/esim_profile/' + this.$route.params.esim_profile_id },
    cur_id () { return this.$route.params.esim_profile_id },
    profile () { return this.simcard.profile },
    load () {
      if (this.simcard) {
        return this.simcard.load === undefined || this.simcard.load
      }
      return true
    }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'esim_profile_section') {
        this.set_simcard()
      } else {
        clearInterval(this.interval)
      }
    },
    load () {
      clearInterval(this.interval)
      if(this.load === false && this.simcard.profile !== null) {
        this.interval = setInterval(() => {
          this.$store.dispatch('updateEsimProfileProfile', this.cur_id)
        }, this.$store.getters.getSimcardDevicesProfileUpdate)
      }
    }
  },

  activated(){
    if(!this.active) {
      this.set_simcard()

      this.interval = setInterval(() => {
        this.set_simcard()
      }, this.$store.getters.getEsimProfileUpdate)
    }
  },

  deactivated () {
    clearInterval(this.interval)
    this.active = false
  },
  methods: {
    OnChange (value) {
      this.change = value
    },
    ProveSaveOnLeave (next) {
      if(this.section === 'profile' && this.change) {
        const answer = window.confirm(this.translate('device.profile_not_save'))
        if (answer) {
          this.$refs.profile.cancel()
          next()
        } else {
          next(false)
        }
      } else {
        next()
      }

    },

    set_simcard () {
      if (this.cur_id) {
        this.$store.dispatch('updateEsimProfileProfile', this.cur_id)
        this.simcard = this.$store.getters.getEsimProfileById(+this.cur_id)
      }
    }
  }
}

</script>
